import { Component, input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-separator',
  imports: [],
  template: '',
  styleUrl: './separator.component.css'
})
export class SeparatorComponent {

  type = input<'horizontal' | 'vertical'>('horizontal')
  style = input<'solid' | 'dashed' | 'dashed-thin' | 'dotted'>('solid')

  @HostBinding('class')
  get hostClass(): string {
    const typeClass = this.type()
    const styleClass = this.style()

    if (styleClass === 'solid') {
      return typeClass
    }

    return `${typeClass} ${styleClass}`
  }

}
